import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// __ __ Packages/Style/Media __ __ //
import StepWizard from "react-step-wizard";
import { toast } from "react-toastify";
import "./WirelessDeals.css";
import LeadCapture from "./LeadCapture";
import LastStep from "./LastStep";
import LeadDetailCapture from "./LeadDetailCapture";
import Deals from "./Deals";
// __ __ Components/Helpers __ __ //
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
const stripePublicKey = process.env.REACT_APP_STRIPE_KEY;
const stripePromise = loadStripe(stripePublicKey);

const WirelessDeals = () => {
  const [serviceZipcode, setServiceZipcode] = useState("");
  const { search } = useLocation();
  const [leadId, setLeadId] = useState("");
  const [leadFound, setLeadFound] = useState(false);
  const [step, setStep] = useState("1");
  const [flag, setFlag] = useState(false);
  const [captureFlag,setCaptureFlag]=useState(false);
  const [data, setData] = useState({
    phone: "",
    email: "",
    zipcode: "",
    type: [],
    preferredDevice: "",
  });
  const queryParams = new URLSearchParams(search);
  const lead = queryParams.get("leadId");
  useEffect(() => {
    if (lead) {
      setLeadId(lead);
      setLeadFound(true);
      setFlag(true);
      setCaptureFlag(true)
    }
  }, []);

  // console.log("stripePromise", stripePromise);
  return (
    <StepWizard>
      <LeadCapture
        setLeadId={setLeadId}
        setData={setData}
        leadFound={leadFound}
        setLeadFound={setLeadFound}
        flag={flag}
        leadId={leadId}
      />
      <LeadDetailCapture
        setServiceZipcode={setServiceZipcode}
        setData={setData}
        leadId={leadId}
        data={data}
        leadFound={leadFound}
        setFlag={setFlag}
        flag={flag}

      />
      <Deals
        serviceZipcode={serviceZipcode}
        leadId={leadId}
        setFlag={setFlag}
        flag={flag}
        data={data}
        setStep={setStep}
        leadFound={leadFound}
      />
      <Elements stripe={stripePromise}>
        <LastStep leadId={leadId} flag={flag} step={step} />
      </Elements>
      {/* <LastStep leadId={leadId} flag={flag} /> */}
    </StepWizard>
  );
};

export default WirelessDeals;
